export const discountCardCodes = {
  INTER: 'INTER',
  FIP: 'FIP',
  SNCX: 'SNCX',
  DUTYSNCF: 'DUTYSNCF',
  VIP_RP: 'VIP_RP',
  INVIT: 'INVIT'
};
